// Libs
import classNames from 'classnames/bind';
import { Box, Stack } from '@mui/material';
import { ReactElement, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
// Components, Layouts, Pages
// Others
import { BACK_TO_PREVIOUS_PAGE } from '~/utils/constants/common';
import usePageHeader from '~/utils/hooks/usePageHeader';
// Styles, images, icons
import styles from './ChildrenPage.module.scss';

type Props = {
  id?: string;
  title?: string;
  children?: ReactElement;
  childrenToolbar?: ReactElement;
  onBackToPreviousPage?: () => void;
};

const cx = classNames.bind(styles);

const ChildrenPage = (props: Props) => {
  //#region Destructuring Props
  const { id, title, children, childrenToolbar, onBackToPreviousPage } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const navigate = useNavigate();
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const handleBackToPreviousPage = useCallback(() => {
    if (!onBackToPreviousPage) {
      navigate(BACK_TO_PREVIOUS_PAGE);
      return;
    }

    onBackToPreviousPage();
  }, [onBackToPreviousPage, navigate]);
  //#endregion Handle Function

  usePageHeader(title ?? '', handleBackToPreviousPage);

  return (
    <Stack id={id || 'childrenPage'} className={cx('container')} spacing={'20px'}>
      {childrenToolbar && (
        <Box component={'div'} className={cx('actionsStrip')}>
          {childrenToolbar}
        </Box>
      )}

      <Box component={'div'} className={cx('childrenBody')}>
        {children}
      </Box>
    </Stack>
  );
};

export default ChildrenPage;
